import { Card, CardBody, Validation } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@/components/head/PageTitle';
import { AppShellContents } from '@/components/layout/AppShell';
import { GenderToggle } from '@/components/toggles/GenderToggle';
import { TopBar } from '@/components/topBar/TopBar';
import { TopBarHeading } from '@/components/topBar/TopBarHeading';

const SettingsSection = ({ children }: { children: React.ReactNode }) => (
  <section className="flex flex-col gap-y-1">{children}</section>
);

export const SelectDefaultGender = () => {
  const { t } = useTranslation(['navigation', 'preferences']);
  return (
    <>
      <PageTitle>{t('primary.settings')} </PageTitle>
      <AppShellContents
        topBar={
          <TopBar>
            <TopBarHeading>{t('primary.settings')}</TopBarHeading>
          </TopBar>
        }
      >
        <Card>
          <CardBody>
            <SettingsSection>
              <GenderToggle />
              <Validation type="info">{t('data.gender.description', { ns: 'preferences' })}</Validation>
            </SettingsSection>
          </CardBody>
        </Card>
      </AppShellContents>
    </>
  );
};
